import { Injectable, signal } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class LoaderState {
	readonly isLoading = signal(true)

	show(): void {
		this.isLoading.set(true)
	}

	hide(): void {
		this.isLoading.set(false)
	}
}
